// Directive to format currency input added in PipesModule 

import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[currencyFormat]'
})
export class CurrencyFormatPipe {

  constructor(private el: ElementRef) {}

@HostListener('blur', ['$event'])
  onBlur(event: any) {
    const input = event.target;
    let value = input.value.replace(/[^0-9.-]/g, ''); 
    const num = parseFloat(value);
    if (isNaN(num)) {
      input.value = '$0.00';
    } else {
      const formatted = '$' + num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      input.value = formatted;
    }
  }

  @HostListener('focus', ['$event'])
  onFocus(event: any) {
    const input = event.target;
    input.value = input.value.replace(/[$,]/g, '');
  }

}